import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { AssetDatabase } from 'pages/assetDatabase/AssetDatabase'
// eslint-disable-next-line boundaries/element-types
import { assetDBSearchSchema } from 'types'

export const Route = createFileRoute('/assets/$siteID/')({
  component: RouteComponent,
  validateSearch: zodValidator(assetDBSearchSchema),
})

function RouteComponent() {
  const search = Route.useSearch()
  return (
    <>
      <AssetDatabase
        initialFilters={{
          asset: search.asset,
          lastInspection: search.lastInspection,
          lastUpdated: search.lastUpdated,
          components: search.components,
          area: search.area,
          areaDescription: search.areaDescription,
          erpId: search.erpId,
          criticality: search.criticality,
        }}
      />
    </>
  )
}
